export default class {
  constructor(submissionData) {
    // student card data
    this.studentName =
      `${submissionData.studentFirstName} ${submissionData.studentLastName}`;
    this.studentExtId = submissionData.studentExtId;
    this.birthDate = submissionData.birthDate;
    this.gender = submissionData.gender;
    this.grade = submissionData.grade;
    this.schoolName = submissionData.studentSchoolName;
    this.serviceName =
      `${submissionData.planTypeName}: ${submissionData.serviceType}`;
    this.serviceTypeName = submissionData.serviceType;
    this.schoolCode = submissionData.schoolCode;
    this.frequency = submissionData.frequency;
    this.esy = submissionData.serviceEsy;
    this.startDate = submissionData.serviceStartDate;
    this.endDate = submissionData.serviceEndDate;
    this.notes = submissionData.notes;
    // submission data on student
    this.providerUserId = submissionData.providerUserId;
    this.providerHUserId = submissionData.providerHUserId;
    this.providerId = submissionData.providerId;
    this.serviceId = submissionData.supportId;
    this.serviceTypeId = submissionData.supportTypeId;
    this.studentId = submissionData.studentId;
    this.hStudentId = submissionData.hStudentId;
  }
}



// WEBPACK FOOTER //
// ./src/utils/student-class.js